"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MailerClient = void 0;
const secretjs_1 = require("secretjs");
class MailerClient {
    constructor(addr, hash, mailer, client, chainId) {
        this.addr = addr;
        this.hash = hash;
        this.mailer = mailer;
        this.client = client;
        this.chainId = chainId;
    }
    async getBlockHeight() {
        const latestBlock = await this.client.query.tendermint.getLatestBlock({});
        const blockHeight = latestBlock.block?.header?.height;
        if (!blockHeight) {
            throw new Error("Unable to retrieve block height");
        }
        return blockHeight;
    }
    async getBackup(tid) {
        const permit = await (0, secretjs_1.newPermit)(this.mailer, (0, secretjs_1.pubkeyToAddress)(this.mailer.publicKey), this.chainId, "", [this.addr], [], false);
        const res = await this.client.query.compute.queryContract({
            contract_address: this.addr,
            code_hash: this.hash,
            query: {
                get_backup: {
                    tid,
                    block_height: await this.getBlockHeight(),
                    permit,
                    padding: "",
                },
            },
        });
        if (typeof res === "string") {
            throw new Error("Query error: " + res);
        }
        return { email: res.email, code: res.nonce_encrypt };
    }
    async getRecovery(tid) {
        const permit = await (0, secretjs_1.newPermit)(this.mailer, (0, secretjs_1.pubkeyToAddress)(this.mailer.publicKey), this.chainId, "", [this.addr], [], false);
        const res = await this.client.query.compute.queryContract({
            contract_address: this.addr,
            code_hash: this.hash,
            query: {
                get_recovery: {
                    tid,
                    block_height: await this.getBlockHeight(),
                    permit,
                    padding: "",
                },
            },
        });
        if (typeof res === "string") {
            throw new Error("Query error: " + res);
        }
        return { email: res.email, code: res.nonce_encrypt };
    }
    async getTransfer(tid) {
        const permit = await (0, secretjs_1.newPermit)(this.mailer, (0, secretjs_1.pubkeyToAddress)(this.mailer.publicKey), this.chainId, "", [this.addr], [], false);
        const res = await this.client.query.compute.queryContract({
            contract_address: this.addr,
            code_hash: this.hash,
            query: {
                get_transfer: {
                    tid,
                    block_height: await this.getBlockHeight(),
                    permit,
                    padding: "",
                },
            },
        });
        if (typeof res === "string") {
            throw new Error("Query error: " + res);
        }
        const code = tid.toString() + "#" + res.nonce;
        return { email: res.email, code };
    }
}
exports.MailerClient = MailerClient;
